export default __webpack_public_path__ + "static/media/RevengeOfTheSynth-MasteredFinal.536a7b24.mp3";